import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { ToolbarModule } from 'primeng/toolbar';
import { CoreModule } from '../core/core.module';
import { CountrySelectorComponent } from './components/country-selector/country-selector.component';
import { ConfirmDialogComponent } from './components/dialogs/confirm-dialog/confirm-dialog.component';
import { FinalizeSignupDialogComponent } from './components/dialogs/finalize-signup-dialog/finalize-signup-dialog.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PasswordInputComponent } from './components/password-input/password-input.component';
import { PhoneNumberInputComponent } from './components/phone-number-input/phone-number-input.component';
import { TableHeaderComponent } from './components/table-header/table-header.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { PrimeNgModule } from './themes/primeng.module';
import { FullScreenLoaderComponent } from './components/fullscreen-loader/fullscreen-loader.component';
import { FixedTextAreaComponent } from './components/fixed-text-area/fixed-text-area.component';

@NgModule({
  imports: [
    CommonModule,
    PrimeNgModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PdfViewerModule,
    BadgeModule,
    ButtonModule,
    ChipModule,
    ToolbarModule,
    NgOptimizedImage,
    RouterLink,
  ],
  exports: [
    PrimeNgModule,
    FormsModule,
    ReactiveFormsModule,
    LanguageSelectorComponent,
    CountrySelectorComponent,
    PhoneNumberInputComponent,
    PasswordInputComponent,
    TranslateModule,
    FinalizeSignupDialogComponent,
    PdfViewerModule,
    TopbarComponent,
    TableHeaderComponent,
    PageNotFoundComponent,
    FullScreenLoaderComponent,
    FixedTextAreaComponent
  ],
  declarations: [
    LanguageSelectorComponent,
    CountrySelectorComponent,
    PhoneNumberInputComponent,
    PasswordInputComponent,
    ConfirmDialogComponent,
    FinalizeSignupDialogComponent,
    TopbarComponent,
    TableHeaderComponent,
    PageNotFoundComponent,
    FullScreenLoaderComponent,
    FixedTextAreaComponent
  ],
})
export class SharedModule {}
